export const menuItems = [
    { name: "videos", label: "videos" },
    { name: "store", label: 'store'}
];
